import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Helmet } from 'react-helmet';
import Layout from 'Components/Layout';
import UserClasses from '../users/Users.module.css';
import { useNavigate } from 'react-router-dom';
import { Services } from 'Services';
import { Success, Error } from 'Util/Toast';
import { Button } from '@mui/material';
import { BsCloudUpload } from 'react-icons/bs';
import ReactLoading from 'react-loading';
import CommonCategoryClasses from '../commoncssfiles/CategoryCommon.module.css';
import CommonTutorClasses from '../commoncssfiles/CategoryTutor.module.css';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import ProductWrapperClasses from './Products.module.css';
import ProductClasses from '../products/Products.module.css';
import { IoMdAddCircleOutline } from 'react-icons/io';
import { RxCross2 } from 'react-icons/rx';
import AddProductVariant from './AddProductVariant';

const AddProduct = () => {
    const { register, control, handleSubmit, setValue, setError, formState: { errors } } = useForm(
        {
            defaultValues: {
                variant: [{ metricValue: "" }]
            }
        }
    );
    const navigate = useNavigate();

    // Modified to handle multiple images with UploadImages API
    const [imageUrls, setImageUrls] = useState([]);
    const [imageFiles, setImageFiles] = useState([]);
    const [imageUploading, setImageUploading] = useState(false);

    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(false);
    const [locationId, setLocationId] = useState('');
    const [nutritionalValues, setNutritionalValues] = useState([
        { key: 'Calorie', value: 0 },
        { key: 'Added sugars', value: 0 },
        { key: 'Biotin', value: 0 },
        { key: 'Calcium', value: 0 },
        { key: 'Chloride', value: 0 },
        { key: 'Choline', value: 0 },
        { key: 'Cholesterol', value: 0 },
        { key: 'Chromium', value: 0 },
        { key: 'Copper', value: 0 },
        { key: 'Dietary Fiber', value: 0 },
        { key: 'Fat', value: 0 },
        { key: 'Folate/Folic Acid', value: 0 },
        { key: 'Iodine', value: 0 },
        { key: 'Iron', value: 0 },
        { key: 'Magnesium', value: 0 },
        { key: 'Manganese', value: 0 },
        { key: 'Molybdenum', value: 0 },
        { key: 'Niacin', value: 0 },
        { key: 'Pantothenic Acid', value: 0 },
        { key: 'Phosphorus', value: 0 },
        { key: 'Potassium', value: 0 },
        { key: 'Protein', value: 0 },
        { key: 'Riboflavin', value: 0 },
        { key: 'Saturated fat', value: 0 },
        { key: 'Selenium', value: 0 },
        { key: 'Sodium', value: 0 },
        { key: 'Thiamin', value: 0 },
        { key: 'Total carbohydrate', value: 0 },
        { key: 'Vitamin A', value: 0 },
        { key: 'Vitamin B6', value: 0 },
        { key: 'Vitamin B12', value: 0 },
        { key: 'Vitamin C', value: 0 },
        { key: 'Vitamin D', value: 0 },
        { key: 'Vitamin E', value: 0 },
        { key: 'Vitamin K', value: 0 },
        { key: 'Zinc', value: 0 },
    ]);
    const [variants, setVariants] = useState([]);
    const [varianterror, setVariantError] = useState(false);
    const [err, setErr] = useState(false);

    const handleAddNutritionalValue = () => {
        const newNutritionalValue = { key: '', value: '', unit: "" };
        setNutritionalValues([...nutritionalValues, newNutritionalValue]);
    };

    const handleRemoveNutritionalValue = (index) => {
        const updatedNutritionalValues = [...nutritionalValues];
        updatedNutritionalValues.splice(index, 1);
        setNutritionalValues(updatedNutritionalValues);
    };

    const handleVariantsChange = (newVariants) => {
        setVariants(newVariants);
    };

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const token = { Authorization: `token ${localStorage.getItem('Token')}` };
                const response = await Services.getCategories(token);

                if (response.Status === 1) {
                    setCategories(response.categories);
                    setLoading(false);
                } else {
                    console.error('Error fetching categories:', response.Message);
                    setLoading(false);
                }
            } catch (error) {
                console.error('Error fetching categories:', error);
                setLoading(false);
            }
        };

        fetchCategories();
    }, []);

    // Modified to use UploadImages API for multiple file uploads
    // Modified filehandleChange function to handle your API response structure
    const filehandleChange = async (event) => {
        const files = event.target.files;
        if (!files || files.length === 0) return;

        setImageUploading(true);

        try {
            // Create FormData with all selected files
            const formData = new FormData();

            // Append all files to FormData
            for (let i = 0; i < files.length; i++) {
                const currentFile = files[i];

                if (
                    currentFile.type === 'image/png' ||
                    currentFile.type === 'image/jpeg' ||
                    currentFile.type === 'image/webp'
                ) {
                    formData.append('images', currentFile);
                    formData.append("folder", "product-images");
                } else {
                    alert(`${currentFile.name} is not a valid image format. Only PNG, JPEG, and WebP are accepted.`);
                    setImageUploading(false);
                    return;
                }
            }

            // Upload all images at once using UploadImages API
            const uploadResponse = await Services.UploadImages(formData);

            if (uploadResponse.Status === 1) {
                // Access the Files array from your API response
                const uploadedImages = uploadResponse.Files || [];

                // Add new images to existing ones using the correct property names
                setImageUrls(prev => [...prev, ...uploadedImages.map(img => img.ImageURL)]);
                setImageFiles(prev => [...prev, ...uploadedImages.map(img => img.ImageID)]);

                // Update form value with all filenames
                setValue('imageUrl', [...imageFiles, ...uploadedImages.map(img => img.ImageID)]);

                Success('Images uploaded successfully!');
            } else {
                Error(uploadResponse.Message || 'Failed to upload images');
            }

        } catch (error) {
            console.error('Error uploading images:', error);
            Error('Error uploading images');
        } finally {
            setImageUploading(false);
        }
    };

    const handleRemoveImage = (index) => {
        // Remove the image at the specified index
        setImageUrls(prev => prev.filter((_, i) => i !== index));
        const updatedImageFiles = imageFiles.filter((_, i) => i !== index);
        setImageFiles(updatedImageFiles);
        setValue('imageUrl', updatedImageFiles);

    };

    const handleFormSubmit = async (data) => {
        if (imageFiles.length === 0) {
            setError('imageUrl', { type: 'custom', message: 'At least one image is required' });
            Error('Please upload at least one image.');
            setErr(true);
            return;
        } else {
            setErr(false);
        }

        variants.map(async (e) => {
            if (!e.metricValue || !e.metricType || !e.price) {
                setVariantError('please add one variant');
                setErr(true);
                return;
            } else {
                setErr(false);
            }
        });

        if (!err) {
            setLoading(true);
            const requestBody = {
                categoryId: data.categoryId,
                images: imageFiles, // Array of image filenames from UploadImages API
                productName: data.productName,
                description: data.description,
                calorie: data.calorie,
                price: data.price,
                defaultQuantity: data.defaultQuantity,
                basketShopToggle: data.basketShopToggle || false,
                nutritionalValues: data.nutritionalValues || [],
                variants: variants,
                locationId: data.locationId
            };

            const token = { Authorization: `token ${localStorage.getItem('Token')}` };

            try {
                const response = await Services.addProduct(requestBody, token);
                if (response.Status === 1) {
                    console.log('Product added successfully:', response.Message);
                    navigate('/products');
                    Success(response.Message);
                } else {
                    console.error('Error adding product:', response.Message);
                    Error(response.Message || 'Failed to add product');
                }
            } catch (error) {
                console.error('Error adding product:', error);
                Error('Failed to add product');
            } finally {
                setLoading(false);
            }
        }
    }

    // Modified to show multiple images and upload button
    const fileuploadDesign = (
        <div className={CommonTutorClasses["add-item"]} onClick={() => document.getElementById("image").click()}>
            <div className={CommonTutorClasses['upload-image']}>
                {imageUrls.length === 0 && (
                    <div className={CommonTutorClasses['add-item']}>
                        <BsCloudUpload className={CommonTutorClasses['upload-icon']} />
                        <h5>Drag Your Files here</h5>
                        <p>(Only *.jpeg, *.png, *.webp will be accepted)</p>
                    </div>
                )}
                <input
                    type="file"
                    id="image"
                    onChange={filehandleChange}
                    style={{ display: 'none' }}
                    multiple // Enable multiple file selection
                    accept="image/png,image/jpeg,image/webp"
                />
            </div>
        </div>
    );

    // Component to display multiple images with remove option
    const MultipleImagesPreview = () => (
        <div className={ProductClasses['image-preview-container']} style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '10px',
            marginTop: '15px'
        }}>
            {imageUrls.map((url, index) => (
                <div key={index} style={{
                    position: 'relative',
                    width: '120px',
                    height: '120px',
                    marginBottom: '10px'
                }}>
                    <img
                        src={url}
                        alt={`Product ${index + 1}`}
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            borderRadius: '4px'
                        }}
                    />
                    <button
                        type="button"
                        onClick={() => handleRemoveImage(index)}
                        style={{
                            position: 'absolute',
                            top: '-10px',
                            right: '-10px',
                            background: 'white',
                            border: '1px solid #ddd',
                            borderRadius: '50%',
                            width: '25px',
                            height: '25px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            padding: 0
                        }}
                    >
                        <RxCross2 />
                    </button>
                </div>
            ))}
            {imageUploading && (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '10px 0' }}>
                    <ReactLoading type="spin" color="#000" height={30} width={30} />
                    <span style={{ marginLeft: '10px' }}>Uploading...</span>
                </div>
            )}
        </div>
    );

    return (
        <Layout Active={'Products'}>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Add Product</title>
            </Helmet>
            <div className={UserClasses['main-first-container']}>
                <div className={UserClasses['main-data-tab']}>
                    <div className={UserClasses['add-users-btn']}>
                        <Button variant="contained" color="primary" onClick={() => navigate(-1)}>
                            BACK
                        </Button>
                    </div>
                    <div className={ProductWrapperClasses['product-wrapper']} data-aos="zoom-in-down">
                        <h2 className={CommonTutorClasses['main-header']}>Add Product</h2>
                        <form className={ProductWrapperClasses["form"]} onSubmit={handleSubmit(handleFormSubmit)}>
                            <div style={{ width: '400px' }} className={CommonTutorClasses['form-control']}>
                                <label htmlFor="locationId">Location</label>
                                <select
                                    className={CommonTutorClasses['select-input']}
                                    {...register('locationId', { required: true })}
                                    onChange={(e) => setLocationId(e.target.value)}
                                >
                                    <option value="">Select a location</option>
                                    <option value="1">Store</option>
                                    <option value="2">Inventory</option>
                                    <option value="3">Both Store & Inventory</option>
                                </select>
                                {errors.locationId && <p className={ProductClasses['error-text']}>Location is required</p>}
                            </div>
                            <div className={ProductClasses['first-two-divs']}>
                                <div style={{ width: '400px' }} className={CommonTutorClasses['form-control']}>
                                    <label htmlFor="categoryId">Category</label>
                                    <select className={CommonTutorClasses['select-input']} {...register('categoryId', { required: true })}>
                                        <option value="">Select a category</option>
                                        {categories.map(category => (
                                            <option key={category.categoryId} value={category.categoryId}>
                                                {category.categoryName}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.categoryId && <p className={ProductClasses['error-text']}>Category is required</p>}
                                </div>
                                <div style={{ width: '400px' }} className={CommonTutorClasses['form-control']}>
                                    <label htmlFor="productName">Product Name</label>
                                    <input type="text" className={CommonTutorClasses['text-input']} {...register('productName', { required: true })} />
                                    {errors.productName && <p className={ProductClasses['error-text']}>Product name is required</p>}
                                </div>
                            </div>
                            <div className={CommonTutorClasses['form-control']}>
                                <label htmlFor="description">Product Description</label>
                                <textarea style={{ textIndent: '10px' }} rows={10} className={ProductClasses['text-area']} {...register('description', { required: true })}></textarea>
                                {errors.description && <p className={ProductClasses['error-text']}>Product description is required</p>}
                            </div>
                            <div style={{ marginTop: '10px' }} className={CommonTutorClasses['file-upload-wrapper']}>
                                <header>
                                    <h3>
                                        Upload Product Images <span className="important">*</span>
                                    </h3>
                                    <p style={{ fontSize: '0.85rem', color: '#666' }}>
                                        Select multiple images by holding Ctrl (or Cmd) while selecting
                                    </p>
                                </header>
                                <div className={CommonTutorClasses["upload-image"]} required>
                                    {fileuploadDesign}
                                </div>
                                {/* Display uploaded images */}
                                <MultipleImagesPreview />
                                {errors.imageUrl && (
                                    <p className={ProductClasses['error-text']} style={{ marginTop: '10px' }}>
                                        {errors.imageUrl.message}
                                    </p>
                                )}
                            </div>
                            <div className={CommonTutorClasses['form-control']}>
                                <div style={{ marginTop: '10px' }} className={CommonTutorClasses['file-upload-wrapper']}>
                                    <header className={ProductClasses['nutri-cont-main']}>
                                        <h3>
                                            Nutritional Value per 100 Gram <span className="important">*</span>
                                        </h3>
                                        <button className={ProductClasses['key-val-add']} type="button" onClick={handleAddNutritionalValue}>
                                            <IoMdAddCircleOutline />
                                        </button>
                                    </header>
                                    <div className={ProductClasses['key-val']} style={{ overflowX: 'hidden' }}>
                                        <div style={{ marginBottom: '20px' }} className={ProductClasses['inp-key-val']}>
                                            {nutritionalValues.map((nutritionalValue, index) => (
                                                <div style={{ marginTop: '20px', width: '100%' }} className={ProductClasses['main-key-val']} key={index}>
                                                    <input
                                                        type="text"
                                                        defaultValue={nutritionalValue.key}
                                                        {...register(`nutritionalValues[${index}].key`)}
                                                        className={ProductClasses['text-input']}
                                                    />
                                                    <input
                                                        type="number"
                                                        step="any"
                                                        defaultValue={parseFloat(nutritionalValue.value)}
                                                        {...register(`nutritionalValues[${index}].value`, { valueAsNumber: true })}
                                                        className={ProductClasses['text-num-input']}
                                                    />
                                                    <select
                                                        {...register(`nutritionalValues[${index}].unit`)}
                                                        defaultValue={nutritionalValue.unit}
                                                        className={ProductClasses['select-input']}
                                                    >
                                                        <option value="">Select Unit</option>
                                                        <option value="g">Grams (g)</option>
                                                        <option value="mg">Milligrams (mg)</option>
                                                        <option value="µg">Micrograms (µg)</option>
                                                        <option value="mcg">Micrograms (mcg)</option>
                                                        <option value="IU">International Units (IU)</option>
                                                        <option value="RE">Retinol Equivalents (RE)</option>
                                                        <option value="DFE">Dietary Folate Equivalents (DFE)</option>
                                                        <option value="kcal">Kilocalories (kcal)</option>
                                                        <option value="kJ">Kilojoules (kJ)</option>
                                                        <option value="mEq">Milliequivalents (mEq)</option>
                                                        <option value="ppm">Parts Per Million (ppm)</option>
                                                        <option value="mL">Milliliters (mL)</option>
                                                        <option value="µmol">Micromoles (µmol)</option>
                                                        <option value="eq">Equivalents (eq)</option>
                                                    </select>

                                                    {index >= 0 && (
                                                        <button className={ProductClasses['key-remove']} type="button" onClick={() => handleRemoveNutritionalValue(index)}>
                                                            <RxCross2 />
                                                        </button>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <AddProductVariant errors={errors} setVariantError={setVariantError} varianterror={varianterror} register={register} control={control} setValue={setValue} onVariantsChange={handleVariantsChange} />
                            <div className={ProductClasses['form-btn-main']}>
                                {loading && <ReactLoading type="spin" color="#000" height={50} width={50} />}
                                <Button type="submit" disabled={loading || imageUploading}>Add Product</Button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default AddProduct;